import React, { PureComponent } from 'react';

import cls from 'classnames/bind';
import styles from './CountriesOverlay.scss';

import chunk from 'lodash/chunk';

const cx = cls.bind(styles);

const COUNTRIES_IN_COLUMN = 8;

class CountriesOverlay extends PureComponent {
  static propTypes = {};

  static defaultProps = {};

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
    document.addEventListener('click', this.handleClick);
  }

  componentWillUnmount() {
    document.addEventListener('keydown', this.handleKeyDown);
    document.addEventListener('click', this.handleClick);
  }

  handleKeyDown = (e) => {
    const { onHide, isOpen } = this.props;

    if (isOpen && e.key === 'Escape') {
      onHide();
    }
  };

  handleClick = (e) => {
    const { onHide, isOpen, parentRef = {} } = this.props;

    if (isOpen && parentRef.current) {
      if (!parentRef.current.contains(e.target)) {
        onHide();
      }
    }
  };

  handleCountryClick(id) {
    const { onCountryChange } = this.props;
    onCountryChange(id);
  }

  render() {
    const { isOpen, countries } = this.props;

    if (!isOpen) {
      return null;
    }

    const columns = chunk(countries, COUNTRIES_IN_COLUMN);

    return (
      <div className={cx('CountriesOverlay')}>
        {columns.map((col, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <div className={cx('col')} key={i}>
            {col.map(({ name, Icon, id }, index) => (
              // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
              <div
                className={cx('country')}
                onClick={this.handleCountryClick.bind(this, id)}
                // eslint-disable-next-line react/no-array-index-key
                key={index}
              >
                <Icon className={cx('icon')} />
                <span className={cx('name')}>{name}</span>
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  }
}

export default CountriesOverlay;
